import "./DashboardpagesCss/profilePage.css";
import { AiFillEdit } from "react-icons/ai";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FaUserDoctor } from "react-icons/fa6";
import { useEffect, useState } from "react";
// import img1 from "../../Assets/Medical doctor_ 2.png";
import toast from "react-hot-toast";
import { getProfileStatus } from "../../api/api";
import {
  getUserData,
  getUserMobile,
  mergeAndSetUserData,
} from "../../utils/auth";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaEdit } from "react-icons/fa";
// import img1 from "../../Assets/doctorImg.webp";
import img1 from "../../Assets/doctorImg.webp";
import icon1 from "../../Assets/icon1.png";
import icon2 from "../../Assets/icon2.png";
const ProfilePage = () => {
  const { userData } = useOutletContext();
  const [profileData, setProfileData] = useState([]);
  const [patientDetails, setPatientDetails] = useState();

  const navigator = useNavigate();

  const handleEditProfile = (e) => {
    // e.preventDefault();
    navigator("/dashboard/edit-profile", { state: { profileData } });
  };

  const statusHandler = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "#F6A812";
      case "completed":
        return "green";
      case "cancelled":
      case "canceled": // handle both spellings
        return "red";
      default:
        return "gray"; // fallback color
    }
  };

  const appointmentData = [
    {
      drName: "Dr. Roy mukherjee",
      speciality: "Dermatologist",
      date: "12 Sep",
      time: "12:30 PM",
      status: "Pending",
    },
    {
      drName: "Dr. Smith",
      speciality: "Cardiologist",
      date: "15 Sep",
      time: "10:00 AM",
      status: "Completed",
    },
    {
      drName: "Dr. Sharma",
      speciality: "Orthopedic",
      date: "18 Sep",
      time: "02:15 PM",
      status: "Cancelled",
    },
    {
      drName: "Dr. Khan",
      speciality: "Pediatrician",
      date: "20 Sep",
      time: "11:45 AM",
      status: "Pending",
    },
    {
      drName: "Dr. Sen",
      speciality: "Neurologist",
      date: "22 Sep",
      time: "04:00 PM",
      status: "Completed",
    },
  ];

  const bestDoctorData = [
    {
      img: "https://static.vecteezy.com/system/resources/thumbnails/026/375/249/small_2x/ai-generative-portrait-of-confident-male-doctor-in-white-coat-and-stethoscope-standing-with-arms-crossed-and-looking-at-camera-photo.jpg",
      dName: "Soumik Mondal",
      dSpeciality: "Cardiologist",
      rating: 4.5,
    },
    {
      img: "https://static.vecteezy.com/system/resources/thumbnails/026/375/249/small_2x/ai-generative-portrait-of-confident-male-doctor-in-white-coat-and-stethoscope-standing-with-arms-crossed-and-looking-at-camera-photo.jpg",
      dName: "Ananya Sen",
      dSpeciality: "Dermatologist",
      rating: 4.7,
    },
    {
      img: "https://static.vecteezy.com/system/resources/thumbnails/026/375/249/small_2x/ai-generative-portrait-of-confident-male-doctor-in-white-coat-and-stethoscope-standing-with-arms-crossed-and-looking-at-camera-photo.jpg",
      dName: "Rajiv Sharma",
      dSpeciality: "Orthopedic Surgeon",
      rating: 4.6,
    },
    {
      img: "https://static.vecteezy.com/system/resources/previews/022/449/851/non_2x/ai-generated-portrait-of-a-smiling-female-doctor-free-photo.jpg",
      dName: "Priya Das",
      dSpeciality: "Pediatrician",
      rating: 4.8,
    },
    {
      img: "https://static.vecteezy.com/system/resources/previews/024/176/759/non_2x/ai-generated-portrait-of-a-male-doctor-free-photo.jpg",
      dName: "Arindam Chatterjee",
      dSpeciality: "Neurologist",
      rating: 4.9,
    },
  ];

  const paymentHistory = [
    {
      Date: "12 Sep 2025",
      Amount: "1,200",
      Service: "Dr. Roy (Dermatologist)",
      Status: "Pending",
      id: "TXN12345",
    },
    {
      Date: "15 Sep 2025",
      Amount: "900",
      Service: "Dr. Smith (Cardiologist)",
      Status: "Cancelled",
      id: "TXN12346",
    },
    {
      Date: "18 Sep 2025",
      Amount: "2,500",
      Service: "Health Checkup Package",
      Status: "Completed",
      id: "TXN12347",
    },
    {
      Date: "20 Sep 2025",
      Amount: "1,750",
      Service: "Dr. Mehta (Neurologist)",
      Status: "Completed",
      id: "TXN12348",
    },
    {
      Date: "22 Sep 2025",
      Amount: "600",
      Service: "Lab Test (Blood & Urine)",
      Status: "Completed",
      id: "TXN12349",
    },
    {
      Date: "18 Sep 2025",
      Amount: "2,500",
      Service: "Health Checkup Package",
      Status: "Completed",
      id: "TXN12347",
    },
    {
      Date: "20 Sep 2025",
      Amount: "1,750",
      Service: "Dr. Mehta (Neurologist)",
      Status: "Completed",
      id: "TXN12348",
    },
    {
      Date: "22 Sep 2025",
      Amount: "600",
      Service: "Lab Test (Blood & Urine)",
      Status: "Completed",
      id: "TXN12349",
    },
  ];

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  // calculate pagination
  const totalPages = Math.ceil(paymentHistory.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = paymentHistory.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  useEffect(() => {
    getProfileData();
  }, []);

  const [loading, setLoading] = useState(false);

  const getProfileData = async () => {
    try {
      // Retrieve user data using helper
      const user = getUserData();
      if (!user) {
        toast.error("No user data found. Redirecting to login...");
        navigator("/users/login");
        return;
      }

      const mobile = getUserMobile();

      // Prepare API payload
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: user?.user_id || "",
        mobile_no: "",
      };

      console.log("Profile check payload:", payload);

      // API call
      setLoading(true);
      const response = await getProfileStatus(payload);
      console.log("Profile Status Response:", response);

      if (response?.data?.status === "success") {
        const profileData = response.data.data || [];
        const firstProfile = Array.isArray(profileData)
          ? profileData[0]
          : profileData;
        setProfileData(profileData || {});
        setPatientDetails(firstProfile || {});

        // If API returned mobile_no, merge it into stored userData for global availability
        if (firstProfile && (firstProfile.mobile_no || firstProfile.mobile)) {
          mergeAndSetUserData(firstProfile);
        }
      } else {
        console.error("Profile fetch failed:", response?.data?.message);
        toast.error(response?.data?.message || "Unable to fetch profile data");
      }
    } catch (error) {
      console.error("Unexpected error fetching profile data:", error);
      toast.error("Something went wrong while loading your profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    // <div className="container">
    //   <div className="profile-header">
    //     <h2>Profile</h2>
    //   </div>
    //   <div className="dashboard-section">
    //     <div className="user-card">
    //       <div className="userProfile">
    //         {/* <img
    //           src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRtcAdqTgmM7vV8XEkpGumjp0Mcg4TsjTBPQ&s"
    //           alt="User"
    //           className="user-avatar"
    //         /> */}
    //         {patientDetails?.PatientImageFile ? (
    //           <img
    //             src={patientDetails.PatientImageFile}
    //             alt={patientDetails?.PFirstName || "Patient"}
    //             className="patient-img"
    //           />
    //         ) : (
    //           <div className="patient-avatar-fallback">
    //             {patientDetails?.PFirstName?.charAt(0)?.toUpperCase() || "?"}
    //           </div>
    //         )}
    //         <div className="editButtonDiv">
    //           <button className="editButtonClass" onClick={handleEditProfile}>
    //             <span className="btn-text">
    //               <AiFillEdit /> Click to Edit
    //             </span>
    //           </button>
    //         </div>
    //       </div>
    //       <div className="profile-card-insie">
    //         <div className="profile-row">
    //           <p>
    //             <b>Name:</b> {patientDetails?.PFirstName}{" "}
    //             {patientDetails?.PLastName}
    //           </p>
    //           <p>
    //             <b>Gender:</b>{" "}
    //             {patientDetails?.PSex === "M" ? "Male" : "Female"}
    //           </p>
    //           <p>
    //             <b>Mobile No:</b> {patientDetails?.mobile_no}
    //           </p>
    //           <p>
    //             <b>Address:</b> {patientDetails?.address}
    //           </p>
    //         </div>

    //         <div className="profile-row">
    //           <p>
    //             <b>D.O.B:</b> {patientDetails?.dateofbirth}
    //           </p>
    //           <p>
    //             <b>Email:</b> {patientDetails?.email || "N/A"}
    //           </p>
    //           <p>
    //             <b>Zipcode:</b> {patientDetails?.Zipcode}
    //           </p>
    //           <p>
    //             <b>Landmark:</b> {patientDetails?.landmark || "N/A"}
    //           </p>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="right-section">
    //       <div className="promo-card">
    //         <div className="promo-text">
    //           <h2>
    //             Get full free
    //             <br />
    //             medical Check up!
    //           </h2>
    //           <p>29 Nov .... 20:00 PM</p>
    //         </div>
    //         <div className="promo-img">
    //           <img
    //             src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRtcAdqTgmM7vV8XEkpGumjp0Mcg4TsjTBPQ&s"
    //             alt="Doctor"
    //           />
    //         </div>
    //       </div>

    //       <div className="stats-grid">
    //         <div className="stat-card">
    //           <i className="fa fa-user-md"></i>
    //           <h3>
    //             <FaUserDoctor /> 300+ Doctor
    //           </h3>
    //           <p>Available Doctors</p>
    //         </div>
    //       </div>
    //     </div>
    //   </div>

    //   {/* --------- Second Section --------- */}
    //   <div className="second-section">
    //     <div className="left-column">
    //       <div className="health-card">
    //         <div className="doctorTopSec">
    //           <h3 style={{ color: "black" }}>Health Details</h3>
    //         </div>
    //         <ul>
    //           <li>
    //             <b>Blood Pressure:</b> 120/80 mmHg
    //           </li>
    //           <li>
    //             <b>Blood Group:</b> O+
    //           </li>
    //           <li>
    //             <b>Allergies:</b> None
    //           </li>
    //           <li>
    //             <b>Temperature:</b> 98.6°F
    //           </li>
    //           <li>
    //             <b>Weight:</b> 70 kg
    //           </li>
    //         </ul>
    //       </div>
    //       <div className="img-dashboard">
    //         <img src={img1} alt="..." />
    //       </div>
    //     </div>

    //     <div className="doctor-list-card">
    //       <div className="doctorTopSec">
    //         <h3>Recent Appointments</h3>
    //       </div>

    //       {appointmentData.slice(0, 4).map((appt, index) => (
    //         <div className="recordDiv" key={index}>
    //           <div className="doctorInfoDiv">
    //             <p>
    //               <strong>{appt.drName}</strong> <br />({appt.speciality})
    //             </p>
    //           </div>
    //           <div className="dateDivSection">
    //             <p>{appt.date}</p>
    //           </div>
    //           <div className="timeDivSection">
    //             <p>{appt.time}</p>
    //           </div>
    //           <div className="statusDiv">
    //             <p
    //               style={{
    //                 color: statusHandler(appt.status),
    //                 fontWeight: "bold",
    //                 fontSize: "12px",
    //               }}
    //             >
    //               {appt.status}
    //             </p>
    //           </div>
    //         </div>
    //       ))}

    //       <button
    //         className="rbdButton"
    //         onClick={() => navigator("/dashboard/opd-history")}
    //       >
    //         {" "}
    //         <span className="btn-text">View More</span>{" "}
    //       </button>
    //     </div>

    //     {/* Right - Doctor List */}
    //     <div className="doctor-list-card">
    //       <div className="doctorTopSec">
    //         <h3>Doctor List</h3>
    //       </div>

    //       {bestDoctorData.slice(0, 3).map((d, indx) => (
    //         <div className="doctorListDiv" key={indx}>
    //           <div className="doctorImageDiv">
    //             <img src={d.img} alt={d.dName} />
    //           </div>
    //           <div className="doctorInfo">
    //             <p className="doctorName">{d.dName}</p>
    //             <p className="doctorSpeciality">{d.dSpeciality}</p>
    //             <p className="doctorRating">
    //               Rating: <span>{d.rating}</span>
    //             </p>
    //           </div>
    //         </div>
    //       ))}
    //       <button
    //         className="rbdButton"
    //         onClick={() => navigator("/dashboard/book-opd")}
    //       >
    //         {" "}
    //         <span className="btn-text">View More</span>{" "}
    //       </button>
    //     </div>
    //   </div>

    //   {/* --------- Third Section --------- */}
    //   {/* paymnent history and  */}
    //   {/* <div className="third-section">
    //     <div className="payment-history-card">
    //       <div className="paymentTopSec">
    //         <h3>Payment History</h3>
    //       </div>

    //       {currentItems.map((d, i) => (
    //         <div className="payment-record" key={i}>
    //           <div className="payment-info">
    //             <p>
    //               <b>Date:</b> {d.Date}
    //             </p>
    //             <p style={{ marginTop: "5px" }}>
    //               <b>Amount:</b> ₹{d.Amount}
    //             </p>
    //           </div>
    //           <div className="payment-info">
    //             <p>
    //               <b>Doctor / Service:</b> {d.Service}
    //             </p>
    //           </div>
    //           <div className={`payment-status ${d.Status.toLowerCase()}`}>
    //             {d.Status}
    //           </div>
    //           <div className="payment-id">#{d.id}</div>
    //         </div>
    //       ))}

    //       <div className="pagination">
    //         {Array.from({ length: totalPages }, (_, i) => (
    //           <button
    //             key={i}
    //             className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
    //             onClick={() => setCurrentPage(i + 1)}
    //           >
    //             {i + 1}
    //           </button>
    //         ))}
    //       </div>
    //     </div>
    //   </div> */}
    // </div>

    <div className="profile-dashboard">
      <div className="dashboard-header">
        <div>
          <h2>Welcome To,</h2>
          <h1>RB Diagnostic</h1>
          <p>Manage your account, see and edit your details below.</p>
        </div>
      </div>

      <div className="profile-card">
        <div className="profile-left">
          {/* <img
            src={img1}
            alt="Profile"
            className="profile-avatar"
          /> */}
          <div className="profile-avatar">
            {patientDetails?.PFirstName?.charAt(0).toUpperCase()}
          </div>

          <div className="profile-info">
            <div className="name-and-edit">
              <h2>
                {patientDetails?.PFirstName} {patientDetails?.PLastName}
              </h2>
              <button className="profile-edit-btn" onClick={handleEditProfile}>
                <FaEdit color="#0FB7A4" /> Edit Profile
              </button>
            </div>

            <p style={{ color: "#868686" }}>
              {patientDetails?.PSex === "F" ? "Female" : "Male"} |{" "}
              {patientDetails?.dateofbirth}
            </p>

            <div className="info-row">
              <FaPhoneAlt color="#0FB7A4" />{" "}
              <span>{patientDetails?.mobile_no}</span>
            </div>
            <div className="info-row">
              <FaEnvelope color="#0FB7A4" />{" "}
              <span>{patientDetails?.email}</span>
            </div>
           
            <div className="info-row">
              <FaMapMarkerAlt color="#0FB7A4" />
              <span>
                {patientDetails?.address} | {patientDetails?.Zipcode}
              </span>
            </div>
            { patientDetails?.landmark && (
             <div className="info-row">
              <FaMapMarkerAlt color="#0FB7A4" />
              <span> {patientDetails?.landmark}</span>
            </div>
            )}
          </div>
        </div>

        {/* <div className="quick-links">
          <h3>Appointment Quick Links</h3>

          <div className="quick-card blue">
            <div className="profile-icons">
              <img src={icon1} alt="home icon" />
            </div>
            <div>
              <h4 style={{ margin: "0" }}>Book Home Collection</h4>
              <p>Get appointment anytime</p>
            </div>
          </div>

          <div className="quick-card green">
            <div className="profile-icons">
              <img src={icon2} alt="home icon" />
            </div>
            <div>
              <h4>Book OPD Appointment</h4>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ProfilePage;
